import TNHourlyData from './view';

const TNHourlyDataPage = {
    name: 'TNHourlyData',
    list: TNHourlyData
};

export default TNHourlyDataPage;